<template>
  <div ref="videoContainer" class="video-container">
    <video
      ref="videoPlayer"
      class="video-js vjs-default-skin w-full h-full"
      playsinline
      x5-video-player-type="h5"
      x5-playsinline
    ></video>
  </div>
</template>

<script>
import videojs from "video.js";
import "video.js/dist/video-js.css";

export default {
  name: "VideoPlayer",
  props: {
    url: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      player: null,
      isFullscreen: false,
      originalPosition: "",
    };
  },
  methods: {
    // 暴露给父组件的播放方法
    startPlay() {
      if (this.player) {
        this.player.play();
      }
    },
    // 暴露给父组件的停止方法
    stopPlay() {
      if (this.player) {
        this.player.pause();
        this.player.currentTime(0); // 重置播放进度
      }
    },
    // iOS全屏处理
    handleiOSFullscreen() {
      const container = this.$refs.videoContainer;

      if (!this.isFullscreen) {
        this.originalPosition = document.body.style.position;
        document.body.style.position = "fixed";
        Object.assign(container.style, {
          position: "fixed",
          zIndex: "9999",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
        });
      } else {
        document.body.style.position = this.originalPosition;
        Object.assign(container.style, {
          position: "static",
          zIndex: "auto",
          width: "100%",
          height: "214px",
        });
      }

      this.isFullscreen = !this.isFullscreen;
      this.player.trigger("resize");
    },
  },
  mounted() {
    // 判断iOS设备
    const isiOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    console.log(isiOS);
    this.player = videojs(this.$refs.videoPlayer, {
      playsinline: true,
      playbackRates: [1, 1.5, 2, 2.5, 3], // 可选的播放速度
      autoplay: false,
      controls: true,
      controlBar: {
        pictureInPictureToggle: false, // 关闭画中画按钮
        playToggle: true, // 保留播放/暂停按钮
        // fullscreenToggle: !isiOS,// 保留全屏按钮
        fullscreenToggle: true, // 保留全屏按钮
        volumePanel: false, // 关闭音量控制
        currentTimeDisplay: true, // 关闭当前时间显示
        timeDivider: true, // 关闭时间分隔符
        durationDisplay: true, // 关闭总时长显示
        remainingTimeDisplay: true, // 关闭剩余时间显示
        chaptersButton: true, // 是否开启章节按钮
        subtitlesButton: false, // 是否开启字幕按钮
        captionsButton: false, // 是否开启字幕按钮
        playbackRateMenuButton: true, // 是否开启播放速率选择
        progressControl: true,
      },
      techOrder: ["html5"], // 优先使用HTML5播放器
      html5: {
        hls: {
          overrideNative: true, // 强制使用Video.js处理HLS
        },
      },
      userActions: {
        hotkeys: true, // 可用快捷键快进快退
      },
      sources: [
        {
          src: this.url,
          type: "video/mp4",
        },
      ],
    });
    // 监听播放开始事件
    this.player.on("play", () => {
      this.$emit("play-start");
    });

    // 监听播放结束事件
    this.player.on("ended", () => {
      this.$emit("play-end");
    });
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>

<style scoped>
.video-container {
  width: 100%;
  height: var(--base-px-214);
  margin: 0 auto;
  transition: all 0.3s;
}
/* 新增控件栏布局调整 */
::v-deep .video-js .vjs-control-bar {
  display: flex;
  justify-content: space-between;
}

::v-deep .vjs-fullscreen-toggle {
  order: 2; /* 强制全屏按钮在最右侧 */
  margin-left: auto !important; /* 右侧对齐 */
}

::v-deep .vjs-play-control {
  order: 1; /* 播放按钮保持左侧 */
}
/* 隐藏原生全屏样式 */
::v-deep .video-js.vjs-fullscreen {
  position: static !important;
  padding-top: 0 !important;
  width: 100% !important;
  height: 100% !important;
}

::v-deep .video-js .vjs-time-control:not(.vjs-remaining-time),
::v-deep .video-js .vjs-volume-panel,
::v-deep .video-js .vjs-picture-in-picture-control {
  display: none !important;
}
</style>
